import { globalAxiosInstance } from "./globalAxios";
import { ApiResponse } from "./api.response";

export const http = {
  get,
  post,
  logout,
  update,
  remove,
};
function get(routeUrl) {
  return globalAxiosInstance
    .get(routeUrl)
    .then((res) => res)
    .catch((err) => {
      try {
        return ApiResponse(
          false,
          err.response?.data?.message || err.message,
          false,
          err.code,
          0,
        );
      } catch {
        return ApiResponse(false, err.message, false, err.code, 0);
      }
    });
}

function post(routeUrl, data) {
  return globalAxiosInstance
    .post(routeUrl, data)
    .then((res) => res)
    .catch((err) => {
      try {
        return ApiResponse(
          false,
          err.response?.data?.message || err.message,
          false,
          err.code,
          0,
        );
      } catch {
        return ApiResponse(false, err.message, false, err.code, 0);
      }
    });
}

function update(routeUrl, data) {
  return globalAxiosInstance
    .patch(routeUrl, data)
    .then((res) => res)
    .catch((err) => {
      try {
        return ApiResponse(
          false,
          err.response?.data?.message || err.message,
          false,
          err.code,
          0,
        );
      } catch {
        return ApiResponse(false, err.message, false, err.code, 0);
      }
    });
}

function remove(routeUrl) {
  return globalAxiosInstance
    .delete(routeUrl)
    .then((res) => res)
    .catch((err) => {
      try {
        return ApiResponse(
          false,
          err.response?.data?.message || err.message,
          false,
          err.code,
          0,
        );
      } catch {
        return ApiResponse(false, err.message, false, err.code, 0);
      }
    });
}

function logout() {
  localStorage.removeItem("token");
  window.location.replace("/");
}
